export default "/images/vendor/jquery-ui/themes/base/ui-icons_ffffff_256x240.png?74e9fe3d9ced3f6712fe8e987b109292";